import React from "react";
import "../../css/main.css";

const Educate = () => {
  const handleDownload = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let downloadLink;

    if (/android/.test(userAgent)) {
      downloadLink =
        "https://play.google.com/store/apps/details?id=com.ai_alpha_mobile_app&pcampaignid=web_share";
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      downloadLink = "https://apps.apple.com/us/app/ai-alpha/id6473463625";
    } else {
      alert(
        "Device not supported. Download the app from App Store or Play Store."
      );
      return;
    }

    const anchor = document.createElement("a");
    anchor.href = downloadLink;
    anchor.target = "_blank";
    anchor.click();
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
          <h1 className="text-center text-lg-left font-weight-bold text-white ">
            The ultimate crypto education tool
          </h1>
          <p className="text-center text-lg-left subText">
            Crypto for everyone. Learn with confidence.{" "}
          </p>
          <div className="text-center text-lg-left">
            <button className="btn-orange" onClick={handleDownload}>
              Download App
            </button>
            <div className="social-buttons">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <img
                  src="static/images/instagramnew.png"
                  alt="Instagram"
                  className="socialLogo"
                />
              </a>
              <a
                href="https://x.com/aialphaai"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <img
                  src="static/images/twitternew.png"
                  alt="Twitter"
                  className="socialLogo"
                />
              </a>
              <a
                href="https://www.tiktok.com/@aialphaai"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2"
              >
                <img
                  src="static/images/tiktoknew.png"
                  alt="TikTok"
                  className="socialLogo"
                />
              </a>
            </div>
          </div>
          <div className="text-center text-lg-left position-relative animated-image-container">
            <img
              src="static/images/Educate/educate1rm.png"
              alt="Educate"
              className="animated-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Educate;
